import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SysLoginService } from 'app/sys-login/sys-login.service';

export const shopHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loginService = inject(SysLoginService);

  return next(req.clone({ headers: req.headers.set('x-shop', loginService.shop?.shop_ulid || '') }));
};
